import React, { useState, useEffect, useRef } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import MDialog from "components/Shared/MDialog.tsx";
import { MSpinner } from "components/Shared";
import { Button } from "react-md";
import { unassignCases } from "requests/qualityAssurance/index.ts";
import { updateQuickListInPlace } from "actions/homeowner/quickList";
import responseHandler from "responseHandler";

const createQuicklistUpdate = (quickListId, controlNumbers) => {
  const update = [];
  controlNumbers.forEach(c => {
    update.push({
      controlIDNumber: c,
      qaAgent: ""
    });
  });
  return {
    id: quickListId,
    key: "controlIDNumber",
    update
  };
};

const QualityAssuranceUnassign = ({
  visible,
  hideDialog,
  controlNumbers,
  makeToast,
  selectedQuickListId,
  updateQuickList
}) => {
  const [isUnassigning, setIsUnassigning] = useState(false);
  const mounted = useRef(true);

  useEffect(() => {
    return (() => { mounted.current = false; });
  }, []);

  const unassignCallback = () => {
    makeToast("Cases unassigned.", "success");
    finishAssigning();
  };

  const finishAssigning = () => {
    hideDialog();
    setIsUnassigning(false);
  };

  const onUnassign = () => {
    setIsUnassigning(true);
    const payload = { controlIdNumbers: controlNumbers };
    unassignCases(payload, unassignCallback, finishAssigning, mounted);
    const update = createQuicklistUpdate(selectedQuickListId, controlNumbers);
    updateQuickList(update);
  };

  const getContentActions = () => {
    if (isUnassigning) return [];
    const actions = [
      <Button key="cancelUnassignQualityAssurance" raised onClick={hideDialog} >Cancel</Button>
    ];
    if (controlNumbers.length > 0) {
      actions.unshift(<Button key="unassignQualityAssurance" primary raised onClick={onUnassign} >Unassign</Button>);
    }
    return actions;
  };

  return (
    <MDialog
      id="unassign-qa-dialog"
      className="unassign-qa-dialog"
      title="Unassign Cases"
      contentClassName="unassign-qa-dialog-content"
      visible={visible}
      contentActions={getContentActions()}
    >
      {isUnassigning && <MSpinner />}
      {controlNumbers.length === 0 && !isUnassigning && <p>No cases selected. Please use the checkboxes to select cases to unassign.</p>}
      {controlNumbers.length > 0 &&
        <p>Are you sure you want to unassign {`${controlNumbers && controlNumbers.length} ${controlNumbers.length > 1 ? "cases" : "case"}`}?</p>}
    </MDialog>
  );
};

QualityAssuranceUnassign.propTypes = {
  visible: PropTypes.bool.isRequired, // Show/hide the dialog
  hideDialog: PropTypes.func.isRequired, // Function to be called to set visibility to false
  controlNumbers: PropTypes.arrayOf(PropTypes.number).isRequired,  // Array of control numbers to be assigned
  selectedQuickListId: PropTypes.number,  // Id of the selected quick, used to update data
  // From dispatch
  makeToast: PropTypes.func.isRequired,
  updateQuickList: PropTypes.func.isRequired,
};

QualityAssuranceUnassign.defaultProps = {
  controlNumbers: [],
  visible: false,
};

const mapDispatchToProps = dispatch => ({
  makeToast(text, type) {
    responseHandler.customToast(text, type, dispatch);
  },
  updateQuickList(update) {
    dispatch(updateQuickListInPlace(update));
  },
});

export default connect(null, mapDispatchToProps)(QualityAssuranceUnassign);